import React from "react";
import { useDashboard } from "../../context/DashboardContext";

const FinancialSummary = () => {
  const { metrics } = useDashboard();

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h3 className="text-gray-500 text-lg mb-2">Equity</h3>
        <p className="text-2xl font-semibold text-emerald-500">
          {metrics.equity}
        </p>
      </div>

      <div className="bg-white p-6 rounded-lg shadow-sm">
        <h3 className="text-gray-500 text-lg mb-2">F&O</h3>
        <p className="text-2xl font-semibold text-emerald-500">
          {metrics.fAndO}
        </p>
      </div>
    </div>
  );
};

export default FinancialSummary;
